import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
	getPropertyStatements,
	getPropertyStatementsCount,
	getPropertyStatementsList,
	getPropertyStatementsLoading,
	getPropertyStatementsTotal,
} from "state/modules/properties";

import StatementsList from "./StatementsList";

interface Props {
	propertyId: string;
}

const PropertyStatementsList = (props: Props): JSX.Element => {
	const { propertyId } = props;

	const dispatch = useDispatch();
	const statements = useSelector(getPropertyStatementsList);
	const isLoading = useSelector(getPropertyStatementsLoading);
	const count = useSelector(getPropertyStatementsCount);
	const total = useSelector(getPropertyStatementsTotal);

	const hasMore = useMemo(() => count < total, [count, total]);

	const loadMore = () => {
		if (!isLoading) {
			dispatch(
				getPropertyStatements({
					propertyId,
					isLoadMore: true,
				})
			);
		}
	};

	return (
		<StatementsList
			statements={statements}
			isLoading={isLoading}
			hasMore={hasMore}
			loadMore={loadMore}
			scrollableTarget="propertyDetailsListContainer"
		/>
	);
};

export default PropertyStatementsList;
